import React from "react";
import { BarChart } from "../assets/svg";
const MetricCard = (props) => {
  return (
    <div className="metricCard" onClick={props.onClick}>
      <div className={props.selected ? "selected" : ""}>
        <div className="metricCard-content">
          <div className="metricCard-content-icon">
            <BarChart />
          </div>
          <div className="metricCard-content-title">
            <p className="metricCard-content-title-heading">{props.title}</p>
            <p className="metricCard-content-title-info">{props.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetricCard;
